import tempStorage from 'usage-tracker-core/containers/tempStorage';
import { makeUuid } from 'usage-tracker-core/common/helpers';
import { hamplitudeKey } from 'usage-tracker-core/storageKeys';
import { createTracker } from 'usage-tracker-anonymous';
import { getUuid } from '../utils';
export default {
  init: (options, {
    history: {
      location
    }
  }) => {
    const tracker = createTracker(options); // Attempt to retrieve an existing deviceId from the URL
    // but if this returns undefined, then it either means that we're not storing
    // UUID on the URL due to (storeUuidOnUrl) or we failed to set an UUID on the URL
    // This is a fallback that ensures that we always have an UUID and are able to do anonymous tracking
    // Note: In the future we want to first attempt to retrieve the UUID from the sessionStorage

    const deviceId = getUuid(location) || makeUuid();
    tracker.setProperties({
      deviceId
    });
    return tracker;
  },
  switch: (_, {
    history: {
      location,
      replace
    },
    storeUuidOnUrl
  }) => {
    // Allow consumers to decide if they want to store the UUID on the URL
    if (storeUuidOnUrl === true) {
      // Note: In the future we want to first attempt to retrieve the UUID from the sessionStorage
      let uuidQueryParam = getUuid(location); // Validates if either an existing UUID is present or not
      // or if it has some sort of weird format (should always be smaller or equal than 64 characters)

      if (uuidQueryParam === undefined || uuidQueryParam.length > 64) {
        // If not, we generate a new UUID and set it on the URL
        uuidQueryParam = makeUuid();
      }

      const searchParams = new URLSearchParams(location.search);
      searchParams.set('uuid', uuidQueryParam);
      replace(`${location.pathname}?${searchParams}`);
    } // Clears the Amplitude Storage as when switching to Anonymosu Tracking
    // we should clear out the user information
    // If the user happens to switch back to authed tracker, a new device_id
    // and a new session_id will be generated
    // Note: This is a temporary measure until teams adopt Anonymous Tracking correctly


    tempStorage.removeItem(hamplitudeKey);
  }
};